module.exports = __webpack_public_path__ + "src/assets/textures/env/alchemy_table/alchemy_table_2k_bake.png";